module.exports = __webpack_public_path__ + "static/media/PlusData.16380594.svg";